module.exports = __webpack_public_path__ + "static/media/MCC-LOGO-3.52e33804.jpg";